export default __webpack_public_path__ + "static/media/mail.4a41b84f.svg";